import PropTypes from "prop-types";
import { cn } from "@/lib/utils";
import { MessageCircle, Mail, MessageSquare, Globe, Phone, Send, Linkedin, Calendar, Facebook, Instagram, HelpCircle } from "lucide-react";
import { BrandChannelMark, hasBrandChannelMark } from "@/components/common/BrandChannelMark";

const map = {
  whatsapp: { Icon: MessageCircle, label: "WhatsApp", tone: "text-emerald-600 bg-emerald-50 ring-emerald-200" },
  email: { Icon: Mail, label: "Gmail", tone: "text-rose-600 bg-rose-50 ring-rose-200" },
  gmail: { Icon: Mail, label: "Gmail", tone: "text-rose-600 bg-rose-50 ring-rose-200" },
  calendar: { Icon: Calendar, label: "Google Calendar", tone: "text-violet-600 bg-violet-50 ring-violet-200" },
  sms: { Icon: MessageSquare, label: "SMS", tone: "text-violet-600 bg-violet-50 ring-violet-200" },
  webchat: { Icon: Globe, label: "Web Chat", tone: "text-sky-600 bg-sky-50 ring-sky-200" },
  voice: { Icon: Phone, label: "Voice", tone: "text-rose-600 bg-rose-50 ring-rose-200" },
  telegram: { Icon: Send, label: "Telegram", tone: "text-cyan-600 bg-cyan-50 ring-cyan-200" },
  linkedin: { Icon: Linkedin, label: "LinkedIn", tone: "text-blue-600 bg-blue-50 ring-blue-200" },
  reddit: { Icon: MessageCircle, label: "Reddit", tone: "text-orange-600 bg-orange-50 ring-orange-200" },
  quora: { Icon: HelpCircle, label: "Quora", tone: "text-red-600 bg-red-50 ring-red-200" },
  facebook: { Icon: Facebook, label: "Facebook", tone: "text-blue-700 bg-blue-50 ring-blue-200" },
  instagram: { Icon: Instagram, label: "Instagram", tone: "text-pink-600 bg-pink-50 ring-pink-200" },
  slack: { Icon: MessageSquare, label: "Slack", tone: "text-purple-600 bg-purple-50 ring-purple-200" },
  discord: { Icon: MessageSquare, label: "Discord", tone: "text-indigo-600 bg-indigo-50 ring-indigo-200" },
};

export function ChannelIcon({ channel, size = 14, className }) {
  if (hasBrandChannelMark(channel)) {
    return (
      <span className={cn("inline-flex shrink-0", className)} style={{ width: size, height: size }}>
        <BrandChannelMark channelKey={channel} size={size} />
      </span>
    );
  }
  const def = map[channel] || map.email;
  const { Icon } = def;
  return <Icon size={size} className={cn("shrink-0", className)} strokeWidth={1.75} />;
}

export function ChannelBadge({ channel, className }) {
  const def = map[channel] || map.email;
  const { Icon, label, tone } = def;
  return (
    <span
      data-testid={`channel-badge-${channel}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-medium ring-1 ring-inset",
        tone,
        className,
      )}
    >
      {hasBrandChannelMark(channel)
        ? <BrandChannelMark channelKey={channel} size={12} />
        : <Icon size={12} strokeWidth={2} />}
      {label}
    </span>
  );
}

ChannelIcon.propTypes = {
  channel: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
};

ChannelBadge.propTypes = {
  channel: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export const channelLabel = (ch) => (map[ch] || map.email).label;
